import { docReady } from './utils';

const whatsappInit = () => {
  const form = document.getElementById('formI9');
  const floatBtn = document.getElementById('whatsappFloat');
  const floatModalEl = document.getElementById('wpFloatModal');
  const floatForm = document.getElementById('formWpFloat');
  const floatNameInput = document.getElementById('wpNome');
  const bs = window.bootstrap;

  const sendWhatsapp = (msg) => {
    const phone = '5519997896759';
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
    window.open(url, '_blank');
  };

  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const getVal = (id) => document.getElementById(id)?.value?.trim() || '';
  
      const nome = getVal('nomeI9');
      const servico = getVal('servicoI9');
      const data = getVal('dataI9');
      const veiculo = getVal('veiculoI9');
      const lugares = getVal('lugaresI9');
      const saida = getVal('saidaI9');
      const destino = getVal('destinoI9');
      const observacao = getVal('observacaoI9');

      if (!nome || !servico || !data || !veiculo || !lugares || !saida || !destino) {
        console.warn('Preencha todos os campos obrigatórios.');
        return;
      }
  
      const mensagem = [
        `Olá, equipe I9! Gostaria de organizar um transporte.`,
        `Nome: ${nome}`,
        `Serviço: ${servico}`,
        `Data: ${data}`,
        `Veículo: ${veiculo} (${lugares} lugares)`,
        `Saída: ${saida}`,
        `Destino: ${destino}`,
        observacao ? `Obs: ${observacao}` : '',
      ]
        .filter(Boolean)
        .join('\\n');
  
      sendWhatsapp(mensagem);
    });
  }

  if (floatBtn && floatModalEl && floatForm && floatNameInput) {
    const modal = bs ? new bs.Modal(floatModalEl) : null;

    floatBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (modal) modal.show();
    });

    floatForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const nome = floatNameInput.value.trim();
      if (!nome) return;
      const msg = `Olá, sou ${nome || 'Cliente'} e gostaria de falar com a equipe I9.`;
      sendWhatsapp(msg);
      if (modal) modal.hide();
      floatForm.reset();
    });
  }
};

docReady(whatsappInit);
